import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";

import "swiper/swiper-bundle.css";

Swiper.use([Navigation, Pagination, Scrollbar]);

export default Swiper;
